import React from "react";
import ContactEbus from "../../../ebusHomePics/ContactEbus.png";
import Dialog from "../../../ebusHomePics/dialog.png";
import * as Scroll from "react-scroll";

const CustomerRules = (props) => {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <div className="row">
      <div className="w-100 p-0" id="contact-div">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white">
            <b>امور مشتریان ایباس</b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div className="container pt-5 bg-white landings-container">
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>پشتیبانی (امور مشتریان)</b>
          </h2>
          <div className="mt-10 mb-20 d-block d-md-flex">
            <div
              className="col-12 col-md-6 d-flex align-items-center justify-content-center"
              style={{ height: "35rem" }}
            >
              <img
                src={ContactEbus}
                className="w-75 h-75"
                style={{ objectFit: "contain" }}
              />
            </div>
            <div className="col-12 col-md-6">
              <h2 style={{ textAlign: "justify", lineHeight: "40px" }}>
                  <p>مشکلی دارید؟ برای کمک اینجا هستیم...</p>
                  قبل از هرچیزی پاسخ سوالات احتمالی تون رو در این صفحه میتونید مطالعه کنید.(<a href="/faq">صفحه سوالات متداول</a>)
                  اگر بعد از مطالعه‌ی این بخش مجددا سوالی داشتید، یا تو هریک از بخش های سایت مثل;
                  <br />
                  حساب کاربری
                  <br />
                  فرایند خرید بلیط اتوبوس
                  <br />
                  مالی و پرداخت ها
                  <br/>
                  مسیرهای فعال سفر اتوبوسی دچار مشکل شده‌اید، برای رفع مشکل با ما در تماس باشید. #همیشه-به-سفر 
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div className="container pt-5 bg-white landings-container">
          <h2
            className="p-4 col-6 col-md-2"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b> راه های ارتباطی</b>
          </h2>
          <div className="mt-10 mb-20 d-block d-md-flex">
            <div
              className="col-12 col-md-6 d-flex align-items-center justify-content-center"
              style={{ height: "30rem" }}
            >
              <img
                src={Dialog}
                className="w-75 h-75"
                style={{ objectFit: "contain" }}
              />
            </div>
            <div className="col-12 col-md-6">
              <h3 className="mt-4">
                <b>تلفن مرکز تماس مشتریان ایباس : 02171057305</b>
              </h3>
              <h3 className="mt-3 mb-30" style={{ lineHeight: "30px" }}>
                {" "}
                در بخش پشتیبانی( تیم امور مشتریان ایباس ) به صورت 24 ساعته همراه شما هستیم.
                </h3>
              <h3>
                <b>آدرس پست الکترونيکی مشتریان ایباس :</b>
              </h3>
              <h3 className="mt-3" style={{ lineHeight: "30px" }}>
                {" "}
                همراهان ایباس، شما می توانید سوالات، مشکلات، پیشنهادات و
                انتقادات خود را در خصوص خدمات ایباس به آدرس پست الکترونیکی
                ارسال نموده و پاسخ لازم را دریافت
                نمایند.
                <br />
                پست الکترونيکی پشتیبانی: SUPPORT@EBUS.IR
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRules;
